/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlZeroDayAlertNotificationSearchResult } from './ControlZeroDayAlertNotificationSearchResult';
import {
    ControlZeroDayAlertNotificationSearchResultFromJSON,
    ControlZeroDayAlertNotificationSearchResultFromJSONTyped,
    ControlZeroDayAlertNotificationSearchResultToJSON,
} from './ControlZeroDayAlertNotificationSearchResult';

/**
 * 
 * @export
 * @interface ControlGetZeroDayAlertNotificationsResponse
 */
export interface ControlGetZeroDayAlertNotificationsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlGetZeroDayAlertNotificationsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlGetZeroDayAlertNotificationsResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlGetZeroDayAlertNotificationsResponse
     */
    count: number;
    /**
     * 
     * @type {Array<ControlZeroDayAlertNotificationSearchResult>}
     * @memberof ControlGetZeroDayAlertNotificationsResponse
     */
    results: Array<ControlZeroDayAlertNotificationSearchResult>;
}

/**
 * Check if a given object implements the ControlGetZeroDayAlertNotificationsResponse interface.
 */
export function instanceOfControlGetZeroDayAlertNotificationsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlGetZeroDayAlertNotificationsResponseFromJSON(json: any): ControlGetZeroDayAlertNotificationsResponse {
    return ControlGetZeroDayAlertNotificationsResponseFromJSONTyped(json, false);
}

export function ControlGetZeroDayAlertNotificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlGetZeroDayAlertNotificationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'count': json['count'],
        'results': ((json['results'] as Array<any>).map(ControlZeroDayAlertNotificationSearchResultFromJSON)),
    };
}

export function ControlGetZeroDayAlertNotificationsResponseToJSON(value?: ControlGetZeroDayAlertNotificationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlZeroDayAlertNotificationSearchResultToJSON)),
    };
}

